import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getAllDocuments } from './DocumentStore';
import { getAllPauseVideos } from './PauseStore';
import { getWind } from './WindStore';
import { getAllStoriesAndElements } from './StoryStore';
import { getAllDevices, setActiveDevice } from './DeviceStore';
import { getAllWeather } from './WeatherStore';
import { getAllInstructionVideos } from './InstructionStore';

export const reducerName = 'appState';

export const refreshFast = createAsyncThunk(
    'app/refreshFast',
    async (currentStoryId, { dispatch }) => {
        await Promise.all([
            // dispatch(getAllDevices()),
            dispatch(setActiveDevice()),
            dispatch(getAllDocuments()),
            dispatch(getAllPauseVideos()),
            dispatch(getAllInstructionVideos()),
            dispatch(getWind()),
            dispatch(getAllStoriesAndElements(currentStoryId)),
        ]);
    }
);

export const refreshSlow = createAsyncThunk(
    'app/refreshSlow',
    async (_, { dispatch }) => {
        
    }
);

export const refreshHourly = createAsyncThunk(
    'app/refreshHourly',
    async (_, { dispatch }) => {
        await dispatch(getAllWeather());
    }
);

const initialState = {
    status: 'idle', // 'idle' | 'loading' | 'succeeded' | 'failed'
    error: null,
};

const appSlice = createSlice({
    name: reducerName,
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            //refreshFast
            .addCase(refreshFast.pending, (state) => {
                state.status = 'loading';
                state.error = null;
            })
            .addCase(refreshFast.fulfilled, (state) => {
                state.status = 'succeeded';
            })
            .addCase(refreshFast.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error?.message || 'An error occurred';
            })
            //refreshSlow
            .addCase(refreshSlow.pending, (state) => {
                state.status = 'loading';
                state.error = null;
            })
            .addCase(refreshSlow.fulfilled, (state) => {
                state.status = 'succeeded';
            })
            .addCase(refreshSlow.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error?.message || 'An error occurred';
            })
            //refreshHourly
            .addCase(refreshHourly.pending, (state) => {
                state.status = 'loading';
                state.error = null;
            })
            .addCase(refreshHourly.fulfilled, (state) => {
                state.status = 'succeeded';
            })
            .addCase(refreshHourly.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error?.message || 'An error occurred';
            });
    },
});

export default appSlice.reducer;
